<template>
  <div>
    <footer class="footer">
      <div class="footer-middle">
        <div class="container">
          <div class="row">
            <div :class="classColumn + ' mb-2'">
              <div class="text-md-left text-center">
                <h4 class="widget-title">{{ data.title }}</h4>
                <!-- End .widget-title -->
                <p class="d-flex justify-content-center">
                  <!-- text-md-left text-center -->
                  {{ data.description }}
                </p>

                <!-- End .soial-icons -->
              </div>
              <!-- End .widget about-widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->

            <div :class="classColumn">
              <!-- d-flex justify-content-center justify-content-md-start -->
              <div class="widget">
                <h4
                  class="widget-title text-center text-lg-center text-md-left text-sm-center"
                >
                  Link utili
                </h4>
                <!-- End .widget-title -->

                <ul
                  class="widget-list text-center text-lg-center text-md-left text-sm-center"
                >
                  <li v-if="auth">
                    <router-link to="/casi-clinici">Casi clinici</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/forum">Forum</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/meeting">E-meeting</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/library">Biblioteca</router-link>
                  </li>
                  <li v-if="auth">
                    <router-link to="/presentation">Presentazioni</router-link>
                  </li>

                  <li v-if="auth">
                    <router-link to="">Account</router-link>
                  </li>

                  <li><router-link to="/">Log in</router-link></li>
                  <li>
                    <router-link to="/register">Registrati</router-link>
                  </li>
                </ul>
                <!-- End .widget-list -->
              </div>
              <!-- End .widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->

            <div :class="classColumn">
              <div class="widget">
                <h4 class="widget-title text-md-left text-center">
                  Termini e privacy
                </h4>
                <!-- End .widget-title -->

                <ul class="widget-list text-md-left text-center">
                  <li v-for="(page, key) in pages" :key="key">
                    <a :href="'/vascularclass/' + page">{{ key }}</a>
                  </li>
                </ul>
                <!-- End .widget-list -->
              </div>
              <!-- End .widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->

            <div :class="classColumn" v-if="auth">
              <div class="widget">
                <h4 class="widget-title text-md-left text-center">
                  Il tuo account
                </h4>
                <!-- End .widget-title -->
                <ul class="widget-list text-md-left text-center">
                  <li>
                    <router-link to="/profile">Il mio profilo</router-link>
                  </li>
                </ul>
                <!-- End .widget-list -->
              </div>
              <!-- End .widget -->
            </div>
            <!-- End .col-sm-6 col-lg-3 -->
          </div>
          <!-- End .row -->
        </div>
        <!-- End .container -->
      </div>
      <!-- End .footer-middle -->

      <!--<div class="footer-bottom">
        <div class="container">
          <p class="footer-copyright">
            Copyright © 2023 Vascularclass. All Rights Reserved.
          </p>
         
        </div>
       
      </div> -->
      <!-- End .footer-bottom -->
    </footer>
    <!-- End .footer -->

    <div class="mobile-menu-container">
      <div class="mobile-menu-wrapper">
        <span class="mobile-menu-close" @click="closeMenu"
          ><i class="icon-close"></i
        ></span>

        <nav class="mobile-nav">
          <ul class="mobile-menu">
            <li>
              <router-link to="/dashboard" @click="closeMenu">Home</router-link>
            </li>

            <li>
              <router-link to="/casi-clinici" @click="closeMenu"
                >Casi clinici</router-link
              >
            </li>
            <li>
              <router-link to="/forum" @click="closeMenu">Forum</router-link>
            </li>
            <li>
              <router-link to="/meeting" @click="closeMenu"
                >E-meeting</router-link
              >
            </li>
            <li>
              <router-link to="/library" @click="closeMenu"
                >Biblioteca</router-link
              >
            </li>
            <li>
              <router-link to="/presentation" @click="closeMenu"
                >Presentazioni</router-link
              >
            </li>
            <li>
              <router-link to="/profile" @click="closeMenu"
                >Il tuo profilo</router-link
              >
            </li>

            <li v-if="isAdmin">
              <a :href="adminDomain" target="_blank">Amministrazione</a>
            </li>

            <li>
              <!-- <router-link to="/account">Account</router-link> -->
            </li>
          </ul>
        </nav>

        <!-- End .social-icons -->
      </div>
      <!-- End .mobile-menu-wrapper -->
    </div>
    <!-- End .mobile-menu-container -->
  </div>
</template>
 
<script>
import http from "@/services/http";
import $ from "jquery";
window.jQuery = $;
window.$ = $;
import { useAuth } from "@/stores/auth.js";
export default {
  name: "FooterComponent",
  data() {
    return {
      classColumn: "",
      data: [],
      pages: [],
      adminDomain: "",
      isAdmin: false,
      auth: false,
    };
  },
  mounted() {
    const authenticated = useAuth();
    this.auth = authenticated.isAuthenticated();
    this.classColumn =
      authenticated.isAuthenticated() === true ? "col-md-3" : "col-md-4";
    this.getImage();
    this.getStaticPage();
  },
  methods: {
    async getStaticPage() {
      await http
        .get("/all-hidden-page")
        .then((response) => {
          this.pages = response.data.data;
        })
        .catch(function (error) {
          console.log("errore resposnse" + error);
        });
    },
    closeMenu() {
      $("body").removeClass("mmenu-active");
      $(".menu-toggler").removeClass("active");
    },
    async getImage() {
      const data = {
        slug: "login",
      };
      await http
        .post("/dinamic-page", data)
        .then((response) => {
          this.data = response.data.data.content[0];
        })
        .catch(function (error) {
          console.log("errore resposnse" + error);
        });
    },
  },
};
</script>